
import EmployeeMap from "../employee/EmployeeMap.js";
import { SubDomain } from "../SubDomain.js";
import Employee from "./Employee.js";
import EmployeePreferencesDomain from "./preferences/EmployeePreferencesDomain.js";

export default class EmployeesDomain extends SubDomain {
  constructor(domain, storage) {
    super(domain, Employee.MODEL_NAME);
    this.prefsDomain = new EmployeePreferencesDomain(this.domain, storage);
    this.storage = storage.employees_found;
  }

  preferences() {
    return this.prefsDomain;
  }

  list() {
    return this.storage.list;
  }

  findByCompany(companyId) {
    var employees = this.list();
    var found = new EmployeeMap(this.domain);
    for (var i = 0; i < employees.length; i++) {
      var item = employees[i];
      var employee = new Employee(this.domain, item);
      if (employee.company().id() === companyId) {
        found.add(employee);
      }
    }
    return found;
  }
  
  findById(employeeId) {
    var employees = this.list();
    for (var i = 0; i < employees.length; i++) {
      var item = employees[i];
      if (super.toId(item) === employeeId) {
        return new Employee(this.domain, item);
      }
    }
    return new Employee(this.domain);
  }
  
  findByUser(user) {
    return this.findByUserId(user.id());
  }
  
  findByUserId(userId) {
    var employees = this.list();
    var found = new EmployeeMap(this.domain);
    
    for (var i = 0; i < employees.length; i++) {
      var item = employees[i];
      var itemId = super.toId(item.User);
      if (itemId === userId) {
        var employee = new Employee(this.domain, item);
        found.add(employee);
      }
    }

    return found;
  }

  findForCompanyAndUser(company, user) {
    var employees = this.list();
    var found = new EmployeeMap(this.domain);
    
    for (var i = 0; i < employees.length; i++) {
      var item = employees[i];
      var employee = new Employee(this.domain, item);
      var userId = employee.user().id();
      var companyId = employee.company().id();
      if (userId === user.id() && companyId === company.id()) {
        found.add(employee);
      }
    }
    return found.first();
  }
}